import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-guide-text',
  template: `@if (text) {
    <div class="text-container" id="guideText" #textContainer>
      <div class="text" [innerHTML]="text"></div>
      @if (showNext) {
        <ipo-button
          [type]="'inverted'"
          class="button-next"
          (clicked)="onNextText()"
        >
          {{ 'guide.nextSection' | translate }}
        </ipo-button>
      }
    </div>
  }`,
  styleUrls: ['./guide-text.component.scss'],
  standalone: false,
})
export class GuideTextComponent implements OnChanges {
  @Input() text: string;
  @Input() showNext: boolean;
  @Output() nextTextClicked = new EventEmitter<void>();

  @ViewChild('textContainer', { static: false })
  textContainer: ElementRef<HTMLDivElement>;

  ngOnChanges() {
    if (this.textContainer) {
      this.textContainer.nativeElement.scrollTo(0, 0);
    }
  }

  onNextText() {
    this.nextTextClicked.emit();
  }
}
